import { endpoints, API_BASE_URL } from 'app/api/endpoints'
import { LoginInput } from 'EstraSuppliers'

const apiURL = `${API_BASE_URL}/${endpoints.login}`
export const doLogin = async (body: LoginInput) =>
  fetch(apiURL, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(body),
  }).then(res =>
    res.json().then(json => ({
      autorizationHeader: res.headers.get('Authorization'),
      status: res.status,
      json,
    }))
  )
